import React, { useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { Menu } from "primereact/menu";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import axios from "../../../../util/axiosconfig";
import { InputTextarea } from "primereact/inputtextarea";
import { MenuItem } from "primereact/menuitem";
import { InputSwitch, InputSwitchChangeEvent } from "primereact/inputswitch";
import { Paginator, PaginatorPageChangeEvent } from "primereact/paginator";
import { ProgressSpinner } from "primereact/progressspinner";
import DataTableComponent, { ColumnOption } from "../../../common/DataTable";
import { showError, showSuccess } from "../../../../util/ShowStatus";
import { Toast } from "primereact/toast";
import { getErrorMessage } from "../../../../helper/getResponseMessage";
import { FilterButtonSVG } from "../../../../assets/SVGs/FilterButtonSVG";
import { EditButtonSVG } from "../../../../assets/SVGs/EditButtonSVG";
import { useDebounce } from "../../../../util/debounce";
import { Timeline } from "primereact/timeline";
import { Card } from "primereact/card";
import { AutoComplete } from "primereact/autocomplete";
interface Supplier {
  userID: string;
  supplierID: string;
  firstName: string;
  lastName: string;
  displayName: string;
  businessNumber: string;
  userEmail: string;
  address: string;
  country: string;
  countryID: number;
  currencySymbol: string;
  currencyCode: string;
  isActive: boolean;
  isEditable: boolean;
  supplierStatusChangeHistory?: any[];
}
interface InvoiceParams {
  size: number;
  page: number;
  supplierName?: string;
  businessNumber?: string;
  countryID?: number;
  isActive?: boolean;
}
interface Country {
  countryName: string;
  currencySymbol: string;
  countryID: number;
}

interface SupplierResponse {
  result: Supplier[];
  totalRecords: number;
}

interface formErrors {
  supplierName: string | null;
  countryID: number | null;
  businessNumber: string | null;
  address: string | null;
}

function SupplierManagement() {
  const [suppliers, setSuppliers] = useState<Supplier[]>([]);
  // const [filterSuppliers, setFilterSuppliers] = useState<Supplier[]>([]);
  const [dialogVisible, setDialogVisible] = useState(false);
  const [editDialogVisible, setEditDialogVisible] = useState(false);
  const [supplierName, setSupplierName] = useState<string | null>(null);
  const [businessNumber, setBusinessNumber] = useState<string | null>(null);
  const [countryID, setCountryID] = useState<number | null>(null);
  const [address, setAddress] = useState("");
  const [countryOptions, setCountryOptions] = useState<Country[]>([]);
  const [selectedCountry, setSelectedCountry] = useState<number | null>(null);
  const [currencySymbol, setCurrencySymbol] = useState<string>("");
  const [selectedSupplierName, setSelectedSupplierName] = useState<
    string | null
  >(null);
  const [selectedBusinessNumber, setSelectedBusinessNumber] = useState<
    string | null
  >(null);
  const [filterCountryOptions, setFilterCountryOptions] =
    useState<Country | null>(null);
  const [supplierIsActive, setSupplierIsActive] = useState<boolean>(true);
  const [editSupplierName, setEditSupplierName] = useState<string | null>(null);
  const [editBusinessNumber, setEditBusinessNumber] = useState<string | null>(
    null
  );
  const [editCountry, setEditCountry] = useState<Country | null>(null);
  const [editAddress, setEditAddress] = useState("");
  const [selectedSupplierID, setSelectedSupplierID] = useState(""); // State for selected user ID
  const [totalRecords, setTotalRecords] = useState(0); // To hold the total number of records
  const [size, setSize] = useState(10); // Rows per page
  const [first, setFirst] = useState(0);
  const menu = useRef<Menu>(null);
  const [selectSupplierNameInput, setSelectSupplierNameInput] = useState<
    string | null
  >(null);
  const [selectBusinessNumberInput, setSelectBusinessNumberInput] = useState<
    string | null
  >(null);
  const [selectCountryInput, setSelectCountryInput] = useState<string | null>(
    null
  );
  const [supplierNameSuggestions, setSupplierNameSuggestions] = useState<any>(
    []
  );
  const [businessNumberSuggestions, setBusinessNumberSuggestions] =
    useState<any>([]);
  const toast = useRef<Toast>(null);
  const [countrySuggestions, setCountrySuggestions] = useState<Country[]>([]);
  // const isFirstFetch = useRef(true); // Track first fetch
  const [supplierListLoading, setSupplierListLoading] = useState(false);
  const [isSwitchDisabled, setIsSwitchDisabled] = useState(false);
  const [isAddButtonDisabled, setIsAddButtonDisabled] = useState(false);

  const [allSuppliers, setAllSuppliers] = useState<Supplier[]>([]);
  const [isExporting, setIsExporting] = useState<boolean>(false);

  const [isStatusDialogVisible, setIsStatusDialogVisible] =
    useState<boolean>(false);
  const [statusChangeReason, setStatusChangeReason] = useState<string>("");
  const [pendingStatusChange, setPendingStatusChange] = useState<{
    supplierID: string;
    isActive: boolean;
  } | null>(null);
  const [statusChangeReasonError, setStatusChangeReasonError] = useState<
    string | null
  >(null);

  const [viewHistoryPopup, setViewHistoryPopup] = useState<boolean>(false);
  const [supplierStatusChangeActivity, setSupplierStatusChangeActivity] =
    useState<any>([]);
  const [selectedRowData, setSelectedRowData] = useState<any>(null);

  const [formErrors, setFormErrors] = useState<formErrors>({
    supplierName: null,
    countryID: null,
    businessNumber: null,
    address: null,
  });

  const searchSupplierNameWithDebounce = useDebounce(
    selectSupplierNameInput?.trim() ?? null
  );
  const searchBusinessNumberWithDebounce = useDebounce(
    selectBusinessNumberInput?.trim() ?? null
  );

  const page = 0;

  const fetchSuppliers = async (
    page: number,
    size: number,
    userChanged?: boolean,
    type?: string
  ) => {
    // const isUserChanged =
    //   userChanged !== undefined ? userChanged : isFirstFetch.current;
    setSupplierListLoading(true);
    try {
      const params: InvoiceParams = {
        size,
        page,
      };
      // if (selectedSupplierName) {
      //   params.supplierName = selectedSupplierName;
      // }
      if (searchSupplierNameWithDebounce) {
        params.supplierName = searchSupplierNameWithDebounce;
      }
      if (searchBusinessNumberWithDebounce) {
        params.businessNumber = searchBusinessNumberWithDebounce;
      }
      if (filterCountryOptions) {
        params.countryID = filterCountryOptions.countryID;
      }

      if (supplierIsActive !== null) {
        params.isActive = supplierIsActive;
      }

      // const response = await axios.get<SupplierResponse>(
      //   `/admin/supplier/all`,
      //   { params }
      // );
      // setSuppliers(response.data.result);
      // // if (isUserChanged) {
      // //   setFilterSuppliers(response.data.result);
      // // }
      // setTotalRecords(response.data.totalRecords); // Assuming the API returns the total count

      if (type === "export") {
        try {
          setIsExporting(true);
          const response = await axios.get("/admin/export-supplier", {
            params,
            responseType: "blob", // Important for binary data
          });

          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.download = "supplier_report.csv";

          // Append to body and trigger download
          document.body.appendChild(link);
          link.click();

          // Clean up
          link.parentNode?.removeChild(link);
          window.URL.revokeObjectURL(url);
        } catch (error) {}
      } else {
        setSupplierListLoading(true);
        const response = await axios.get("/admin/supplier/all", { params });
        setSuppliers(response.data.result);
        setTotalRecords(response.data.totalRecords); // Assuming the API returns the total count
      }
      setIsExporting(false);
    } catch (error: any) {
      showError(
        error?.response?.data?.Message ?? "",
        toast,
        error?.message ?? ""
      );
    } finally {
      setSupplierListLoading(false);
    }
  };

  const fetchAllSuppliers = async () => {
    try {
      setSupplierListLoading(true);
      const response = await axios.get<SupplierResponse>(
        `/admin/supplier/all?page=-1`
      );
      setAllSuppliers(response.data.result);
      setSupplierListLoading(false);
    } catch (err) {
      const error = getErrorMessage(err);
      setSupplierListLoading(false);
      showError(error, toast);
    }
  };

  useEffect(() => {
    fetchSuppliers(page, size);
    setFirst(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    page,
    size,
    selectedSupplierName,
    selectedBusinessNumber,
    filterCountryOptions,
    supplierIsActive,
    searchSupplierNameWithDebounce,
    searchBusinessNumberWithDebounce,
  ]);

  const onPageChange = (event: PaginatorPageChangeEvent) => {
    setFirst(event.first);
    setSize(event.rows); // Set the number of rows per page
    const currentPage = Math.floor(event.first / event.rows); // Calculate the current page index
    fetchSuppliers(currentPage, event.rows, true); // Fetch users for the new page and size
  };

  const fetchCountryOptions = async () => {
    try {
      const response = await axios.get("/admin/country");
      const countries = response.data.result;
      const countryList = countries.map((country: Country) => ({
        countryName: `${country.countryName} (${country.currencySymbol})`,
        countryID: country.countryID,
        currencySymbol: country.currencySymbol,
      }));
      setCountryOptions(countryList);
      // setFilterCountryOptions(countryList);
    } catch (error) {
      console.error("Error fetching countries:", error);
    }
  };

  useEffect(() => {
    fetchCountryOptions();
    fetchAllSuppliers();
  }, []);

  const validateForm = (type: string) => {
    const errors: Partial<Record<string, string>> = {};

    if (type === "add") {
      if (!supplierName || supplierName?.trim().length === 0)
        errors.supplierName = "Supplier name is required";
      if (!countryID) errors.countryID = "Country is required";
      if (!businessNumber || businessNumber?.trim().length === 0)
        errors.businessNumber = "Business number is required";
    } else if (type === "update") {
      if (!editSupplierName || editSupplierName?.trim().length === 0)
        errors.supplierName = "Supplier name is required";
      if (!editCountry) errors.countryID = "Country is required";
      if (!editBusinessNumber || editBusinessNumber?.trim().length === 0)
        errors.businessNumber = "Business number is required";
    }

    setFormErrors((prev) => ({ ...prev, ...errors }));

    return Object.keys(errors).length === 0; // Returns true if no errors
  };

  const handleAddSupplier = async () => {
    if (!validateForm("add")) return; // Stop submission if validation fails
    const supplierData = {
      displayName: supplierName,
      businessNumber,
      countryID,
      address: address?.trim(),
    };

    try {
      setIsAddButtonDisabled(true);
      await axios.post("/admin/add-supplier", supplierData);
      setIsAddButtonDisabled(false);
      setDialogVisible(false);
      setSupplierName("");
      setBusinessNumber("");
      setCountryID(null);
      setSelectedCountry(null);
      setCurrencySymbol("");
      setAddress("");
      setFirst(page);
      fetchAllSuppliers(); // Fetch all suppliers after adding a new one
      fetchSuppliers(page, size, true);
    } catch (error: any) {
      const errorMessage = getErrorMessage(error);
      // console.error("Error adding user:", error);
      showError(errorMessage, toast);
      setIsAddButtonDisabled(false);
    }
  };
  const handleUpdateSupplier = async () => {
    if (!validateForm("update")) return; // Stop submission if validation fails
    const countryID = editCountry ? editCountry.countryID : 0;
    try {
      // Create the payload with updated user data
      const updatedUserData = {
        supplierID: selectedSupplierID,
        displayName: editSupplierName?.split(" - ")[0]?.trim(),
        businessNumber: editBusinessNumber?.trim(),
        countryID: countryID,
        address: editAddress?.trim(),
      };

      setIsAddButtonDisabled(true);
      // Send the update request to the API
      await axios.post("admin/supplier/update", updatedUserData);
      setIsAddButtonDisabled(false);

      // Close the dialog
      setEditDialogVisible(false);

      // Optionally refresh the users list
      setFirst(page);
      fetchAllSuppliers(); // Fetch all suppliers after adding a new one
      fetchSuppliers(page, size, true);
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      // console.error("Error adding user:", error);
      showError(errorMessage, toast);
      setIsAddButtonDisabled(false);
    }
  };
  const handleEditUser = (editSelectedUser: Supplier) => {
    setEditSupplierName(editSelectedUser.displayName);
    setEditBusinessNumber(editSelectedUser.businessNumber);
    const country = countryOptions.find(
      (c) => c.countryID === editSelectedUser.countryID
    );
    setEditCountry(country || null);
    setSelectedSupplierID(editSelectedUser.supplierID);
    setCurrencySymbol(country ? country.currencySymbol : "");
    setEditAddress(editSelectedUser.address);
    setEditDialogVisible(true);
  };

  const clearFilters = () => {
    setSelectedSupplierName(null);
    setSelectedBusinessNumber(null);
    setFilterCountryOptions(null);
    setSelectSupplierNameInput(null);
    setSelectBusinessNumberInput(null);
    setSelectCountryInput(null);
    setSupplierIsActive(true);
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    type: "supplierName" | "businessNumber" | "country"
  ) => {
    const value = e.target.value;

    // if (type === "supplierName") {
    //   setSelectSupplierNameInput(value);
    //   if (value.length === 0) {
    //     setSelectedSupplierName(null);
    //     setSelectSupplierNameInput(null);
    //     setSupplierNameSuggestions([]);
    //   }
    //   if (value) {
    //     const filteredSuggestions = allSuppliers.filter((supplier) =>
    //       supplier.displayName.split(" - ")[0].toLowerCase().includes(value.toLowerCase())
    //     );
    //     setSupplierNameSuggestions(filteredSuggestions);
    //   } else {
    //     setSupplierNameSuggestions([]);
    //   }
    // } else
    if (type === "businessNumber") {
      setSelectBusinessNumberInput(value);
      if (value.length === 0) {
        setSelectedBusinessNumber(null);
        setSelectBusinessNumberInput(null);
        setBusinessNumberSuggestions([]);
      }
      if (value) {
        const filteredSuggestions = allSuppliers.filter((supplier) =>
          supplier.businessNumber.toLowerCase().includes(value.toLowerCase())
        );
        setBusinessNumberSuggestions(filteredSuggestions);
      } else {
        setBusinessNumberSuggestions([]);
      }
    } else if (type === "country") {
      setSelectCountryInput(value);
      if (value.length === 0) {
        setFilterCountryOptions(null);
        setSelectCountryInput(null);
        setCountrySuggestions([]);
      }
      if (value) {
        // Filter countries that match the suppliers' country IDs
        const filteredSuggestions = countryOptions.filter((country) =>
          allSuppliers.some(
            (supplier) => supplier.countryID === country.countryID
          )
        );

        // Further filter based on the input value
        const finalSuggestions = filteredSuggestions.filter((country) =>
          country.countryName.toLowerCase().includes(value.toLowerCase())
        );

        setCountrySuggestions(finalSuggestions);
      } else {
        setCountrySuggestions([]);
      }
    }
  };

  const handleSuggestionClick = (
    item: Supplier | Country,
    type: "supplierName" | "businessNumber" | "country"
  ) => {
    // if (type === "supplierName") {
    //   // Check if the item is of type Supplier
    //   if ("displayName" in item) {
    //     setSelectedSupplierName(item.displayName.split(" - ")[0]);
    //     setSelectSupplierNameInput(item.displayName.split(" - ")[0]);
    //     setSupplierNameSuggestions([]);
    //   }
    // } else
    if (type === "businessNumber") {
      // Check if the item is of type Supplier
      if ("businessNumber" in item) {
        setSelectedBusinessNumber(item.businessNumber);
        setSelectBusinessNumberInput(item.businessNumber);
        setBusinessNumberSuggestions([]);
      }
    } else if (type === "country") {
      // Since this is a Country type, use name
      if ("countryName" in item) {
        setFilterCountryOptions(item);
        setSelectCountryInput(item.countryName);
        setCountrySuggestions([]);
      }
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === " ") {
      e.stopPropagation(); // Prevent focus shift or parent events
    }
  };

  const items = [
    {
      items: [
        // {
        //   template: (
        //     <div className="tw-flex tw-flex-col tw-gap-2 tw-mx-5 tw-w-62 tw-mt-3">
        //       <label htmlFor="UploadedOn">Supplier Name</label>
        //       <div className="relative">
        //         <input
        //           type="text"
        //           className="tw-border tw-rounded-md tw-p-2 tw-w-full"
        //           value={selectSupplierNameInput ?? ""}
        //           onChange={(e) => handleChange(e, "supplierName")}
        //           onKeyDown={handleKeyDown} // Add the key down handler here
        //           placeholder="Enter supplier name"
        //           style={{ width: "100%", padding: "8px", fontSize: "16px" }}
        //         />
        //         {supplierNameSuggestions.length > 0 ? (
        //           <ul
        //             className="tw-absolute tw-bg-white tw-border tw-border-gray-300 tw-w-full tw-rounded-md tw-mt-2 tw-max-h-60 tw-max-w-[250px] tw-overflow-auto tw-shadow-md"
        //             style={{ zIndex: 1000 }}
        //           >
        //             {supplierNameSuggestions.map((supplier, index) => (
        //               <li
        //                 key={index}
        //                 className="tw-px-3 tw-py-2 tw-cursor-pointer hover:tw-bg-gray-200 tw-text-black"
        //                 onClick={(e) => {
        //                   e.stopPropagation();
        //                   handleSuggestionClick(supplier, "supplierName");
        //                 }}
        //               >
        //                 {supplier.displayName.split(" - ")[0]}
        //               </li>
        //             ))}
        //           </ul>
        //         ) : selectSupplierNameInput?.split(" - ")[0] !==
        //             selectedSupplierName && selectSupplierNameInput !== null ? (
        //           <ul
        //             className="tw-absolute tw-bg-white tw-border tw-border-gray-300 tw-w-full tw-rounded-md tw-mt-2 tw-max-h-60 tw-max-w-[250px] tw-overflow-auto tw-shadow-md"
        //             style={{ zIndex: 1000 }}
        //           >
        //             <li className="tw-px-3 tw-py-2 tw-text-black">
        //               No records found
        //             </li>
        //           </ul>
        //         ) : null}
        //       </div>
        //     </div>
        //   ),
        // },
        {
          template: (
            <div className="tw-flex tw-flex-col tw-gap-2 tw-mx-5 tw-w-62 tw-mt-3 tw-mb-5">
              <label htmlFor="supplierName">Supplier Name</label>
              <div className="tw-relative tw-w-full">
                <AutoComplete
                  id="supplierName"
                  className={`${
                    formErrors.supplierName
                      ? "tw-border-red-600"
                      : "tw-border-gray-300"
                  } tw-px-2 tw-py-1 tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-h-11 placeholder:tw-font-normal tw-w-full`}
                  value={selectSupplierNameInput ?? ""}
                  suggestions={supplierNameSuggestions}
                  itemTemplate={(supplier: Supplier) => {
                    if (supplierNameSuggestions.length === 0) {
                      return <span>No records found</span>;
                    } else
                      return (
                        <span>{supplier.displayName.split(" - ")[0]}</span>
                      );
                  }}
                  completeMethod={(e) => {
                    const query = e.query.toLowerCase();
                    const filtered = allSuppliers.filter((supplier: any) =>
                      supplier.displayName
                        .split(" - ")[0]
                        .toLowerCase()
                        .includes(query)
                    );
                    if (filtered.length === 0) {
                      setSupplierNameSuggestions([
                        {
                          displayName: "No records found",
                          disabled: true,
                        },
                      ]);
                    } else {
                      setSupplierNameSuggestions(filtered);
                    }
                  }}
                  field="displayName"
                  placeholder="Search Supplier Name"
                  onChange={(e) => {
                    if (typeof e.value === "string") {
                      setSelectSupplierNameInput(e.value);
                    } else {
                      setSelectSupplierNameInput(
                        e.value?.displayName.split(" - ")[0]
                      );
                    }
                  }}
                  onClick={(e) => e.stopPropagation()}
                  // Explicitly handle input events
                  inputRef={(el) => {
                    if (el) {
                      el.addEventListener("keydown", (e) => {
                        // Prevent any default handling of space that might be causing issues
                        if (e.key === " " || e.code === "Space") {
                          e.stopPropagation();
                        }
                      });
                    }
                  }}
                  // Make sure the component doesn't filter out spaces
                  forceSelection={false}
                  panelClassName="tw-w-full tw-mt-[11px]"
                  // panelStyle={{ width: '100%' }}
                  appendTo="self"
                />
              </div>
            </div>
          ),
        },
        {
          template: (
            <div className="tw-flex tw-flex-col tw-gap-2 tw-mx-5 tw-w-62 tw-mt-3 tw-mb-5">
              <label htmlFor="supplierName">Business Number</label>
              <div className="tw-relative tw-w-full">
                <AutoComplete
                  id="supplierName"
                  className={`${
                    formErrors.businessNumber
                      ? "tw-border-red-600"
                      : "tw-border-gray-300"
                  } tw-px-2 tw-py-1 tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-h-11 placeholder:tw-font-normal tw-w-full`}
                  value={selectBusinessNumberInput ?? ""}
                  suggestions={businessNumberSuggestions}
                  itemTemplate={(supplier: Supplier) => {
                    return <span>{supplier.businessNumber}</span>;
                  }}
                  completeMethod={(e) => {
                    const query = e.query.toLowerCase();
                    const filtered = allSuppliers.filter((supplier: any) =>
                      supplier.businessNumber.toLowerCase().includes(query)
                    );
                    if (filtered.length === 0) {
                      setBusinessNumberSuggestions([
                        {
                          businessNumber: "No records found",
                          disabled: true,
                        },
                      ]);
                    } else {
                      setBusinessNumberSuggestions(filtered);
                    }
                  }}
                  field="businessNumber"
                  placeholder="Search Business Number"
                  onChange={(e) => {
                    if (typeof e.value === "string") {
                      setSelectBusinessNumberInput(e.value);
                    } else {
                      setSelectBusinessNumberInput(e.value?.businessNumber);
                    }
                  }}
                  onClick={(e) => e.stopPropagation()}
                  // Explicitly handle input events
                  inputRef={(el) => {
                    if (el) {
                      el.addEventListener("keydown", (e) => {
                        // Prevent any default handling of space that might be causing issues
                        if (e.key === " " || e.code === "Space") {
                          e.stopPropagation();
                        }
                      });
                    }
                  }}
                  // Make sure the component doesn't filter out spaces
                  forceSelection={false}
                  panelClassName="tw-w-full tw-mt-[11px]"
                  // panelStyle={{ width: '100%' }}
                  appendTo="self"
                />
              </div>
            </div>
          ),
        },
        // {
        //   template: (
        //     <div className="tw-flex tw-flex-col tw-gap-2 tw-mx-5 tw-w-62 tw-mt-3">
        //       <label htmlFor="UploadedOn">Business Number</label>
        //       <div className="relative">
        //         <input
        //           type="text"
        //           className="tw-border tw-rounded-md tw-p-2 tw-w-full"
        //           value={selectBusinessNumberInput ?? ""}
        //           onChange={(e) => handleChange(e, "businessNumber")}
        //           onKeyDown={handleKeyDown} // Add the key down handler here
        //           placeholder="Enter business no."
        //           style={{ width: "100%", padding: "8px", fontSize: "16px" }}
        //         />
        //         {businessNumberSuggestions.length > 0 ? (
        //           <ul
        //             className="tw-absolute tw-bg-white tw-border tw-border-gray-300 tw-w-full tw-rounded-md tw-mt-2 tw-max-h-60 tw-max-w-[250px] tw-overflow-auto tw-shadow-md"
        //             style={{ zIndex: 1000 }}
        //           >
        //             {businessNumberSuggestions.map((supplier, index) => (
        //               <li
        //                 key={index}
        //                 className="tw-px-3 tw-py-2 tw-cursor-pointer hover:tw-bg-gray-200 tw-text-black"
        //                 onClick={(e) => {
        //                   e.stopPropagation();
        //                   handleSuggestionClick(supplier, "businessNumber");
        //                 }}
        //               >
        //                 {supplier.businessNumber}
        //               </li>
        //             ))}
        //           </ul>
        //         ) : selectBusinessNumberInput !== selectedBusinessNumber &&
        //           selectBusinessNumberInput !== null ? (
        //           <ul
        //             className="tw-absolute tw-bg-white tw-border tw-border-gray-300 tw-w-full tw-rounded-md tw-mt-2 tw-max-h-60 tw-max-w-[250px] tw-overflow-auto tw-shadow-md"
        //             style={{ zIndex: 1000 }}
        //           >
        //             <li className="tw-px-3 tw-py-2 tw-text-black">
        //               No records found
        //             </li>
        //           </ul>
        //         ) : null}
        //       </div>
        //     </div>
        //   ),
        // },
        {
          template: (
            <div className="tw-flex tw-flex-col tw-gap-2 tw-mx-5 tw-w-62 tw-mt-3 tw-mb-4">
              <label htmlFor="UploadedOn">Country</label>
              <div className="relative">
                <input
                  type="text"
                  className="tw-border tw-rounded-md tw-p-2 tw-w-full"
                  value={selectCountryInput ?? ""}
                  onChange={(e) => handleChange(e, "country")}
                  onKeyDown={handleKeyDown} // Add the key down handler here
                  placeholder="Enter country"
                  style={{ width: "100%", padding: "8px", fontSize: "16px" }}
                />
                {countrySuggestions.length > 0 ? (
                  <ul
                    className="tw-absolute tw-bg-white tw-border tw-border-gray-300 tw-w-full tw-rounded-md tw-mt-2 tw-max-h-60 tw-max-w-[250px] tw-overflow-auto tw-shadow-md"
                    style={{ zIndex: 1000 }}
                  >
                    {countrySuggestions.map((country, index) => {
                      return (
                        <li
                          key={index}
                          className="tw-px-3 tw-py-2 tw-cursor-pointer hover:tw-bg-gray-200 tw-text-black"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleSuggestionClick(country, "country");
                          }}
                        >
                          {country.countryName}
                        </li>
                      );
                    })}
                  </ul>
                ) : selectCountryInput !== null &&
                  selectCountryInput !== filterCountryOptions?.countryName ? (
                  <ul
                    className="tw-absolute tw-bg-white tw-border tw-border-gray-300 tw-w-full tw-rounded-md tw-mt-2 tw-max-h-60 tw-max-w-[250px] tw-overflow-auto tw-shadow-md"
                    style={{ zIndex: 1000 }}
                  >
                    <li className="tw-px-3 tw-py-2 tw-text-black">
                      No records found
                    </li>
                  </ul>
                ) : null}
              </div>
            </div>
          ),
        },
        {
          template: (
            <div className="tw-flex tw-flex-col tw-gap-2 tw-mx-5 tw-w-62 tw-mt-3 tw-mb-4">
              <label htmlFor="status">Account Status</label>
              <InputSwitch
                checked={supplierIsActive}
                onChange={(e) => {
                  setSupplierIsActive(e.value);
                }}
              />
            </div>
          ),
        },
        {
          template: (
            <div className="tw-flex tw-flex-col tw-gap-2 tw-mx-5 tw-w-62 tw-mt-3 tw-mb-4">
              <Button
                className="tw-flex tw-px-3 tw-py-2 tw-rounded tw-bg-red-500 tw-font-medium tw-gap-2 tw-text-white"
                onClick={clearFilters} // This function will reset filters
              >
                Clear Filters
              </Button>
            </div>
          ),
        },
      ],
    },
  ];

  const updateSupplierStatus = async (
    supplierID: string,
    isActive: boolean,
    reason: string
  ) => {
    try {
      setSelectedSupplierID(supplierID);
      setIsSwitchDisabled(true);
      const statusResponse = await axios.post("admin/supplier/update", {
        supplierID,
        isActive,
        statusChangeReason: reason,
      });
      setIsSwitchDisabled(false);
      if (statusResponse.status === 200) {
        showSuccess(statusResponse.data.Message, toast);
        const updatedSuppliers = suppliers.map((supplier) =>
          supplier.supplierID === supplierID
            ? { ...supplier, isActive: isActive }
            : supplier
        );
        setSuppliers(updatedSuppliers);
      } else {
        setIsSwitchDisabled(false);
        console.error(
          "Supplier status updated failed:",
          statusResponse.data.result
        );
      }
      setIsSwitchDisabled(false);
      // Reset status change states
      setIsStatusDialogVisible(false);
      setStatusChangeReason("");
      setPendingStatusChange(null);
    } catch (error: any) {
      setIsSwitchDisabled(false);
      console.error("Error updating user status:", error.response.data.Message);
      showError(error.response.data.Message, toast);
      setIsStatusDialogVisible(false);
      setStatusChangeReason("");
      setPendingStatusChange(null);
    }
  };

  const handleStatusChangeClick = (
    supplierID: string,
    currentStatus: boolean
  ) => {
    setPendingStatusChange({
      supplierID,
      isActive: !currentStatus,
    });
    setStatusChangeReason("");
    setIsStatusDialogVisible(true);
  };

  const confirmStatusChange = () => {
    if (!statusChangeReason.trim()) {
      setStatusChangeReasonError(
        "Please provide a reason for the status change"
      );
      return;
    }
    setStatusChangeReasonError(null);
    if (pendingStatusChange) {
      updateSupplierStatus(
        pendingStatusChange.supplierID,
        pendingStatusChange.isActive,
        statusChangeReason
      ).then(() => {
        fetchSuppliers(first / size, size, true);
        setIsStatusDialogVisible(false);
      });
    }
  };

  const formatCreatedDate = (dateString: string) => {
    const date = new Date(dateString);
    const day = date.getUTCDate().toString().padStart(2, "0");
    const month = date.toLocaleString("en-UK", { month: "short" });
    const year = date.getUTCFullYear();
    const hours = date.getUTCHours().toString().padStart(2, "0");
    const minutes = date.getUTCMinutes().toString().padStart(2, "0");
    return `${day} ${month} ${year}, ${hours}:${minutes}`;
  };

  const events: any = supplierStatusChangeActivity?.map((activity: any) => ({
    actionTakerID: activity?.actionTakerID,
    date: activity?.createdDate,
    actionTakerDisplayName: activity?.actionTakerName,
    comment: activity?.statusChangeReason,
    action:
      activity?.previousStatus && activity?.newStatus
        ? `Status changed from ${
            activity.previousStatus.charAt(0).toUpperCase() +
            activity.previousStatus.slice(1).toLowerCase()
          } to ${
            activity.newStatus.charAt(0).toUpperCase() +
            activity.newStatus.slice(1).toLowerCase()
          }`
        : null,
    id: activity?.id,
    previousStatus: activity?.previousStatus,
    newStatus: activity?.newStatus,
  }));

  const customizedMarker = () => (
    <div className="tw-flex tw-justify-center tw-items-center tw-w-5 tw-h-5 tw-rounded-full tw-bg-[#E2E8F0]">
      <div className="tw-w-3 tw-h-3 tw-rounded-full tw-bg-[#00AFEE]"></div>
    </div>
  );

  const customizedContent = (item: any) =>
    item?.action ? (
      <Card className="activity-card tw-bg-gray-50">
        <div className="activity-container tw-flex tw-justify-between tw-items-center tw-mb-4">
          <span className="activity-date tw-text-ellipsis tw-overflow-hidden tw-max-w-52">
            {formatCreatedDate(item?.date)}
          </span>
        </div>
        <span className="activity-content tw-text-ellipsis tw-overflow-hidden tw-max-w-52">
          <span>
            <span className="tw-font-medium tw-text-gray-700">
              {item?.action}
            </span>{" "}
            <span className="tw-text-gray-600">
              by {item?.actionTakerDisplayName}
            </span>
          </span>
        </span>
        <div className="tw-flex tw-justify-between tw-items-center tw-mt-1 tw-font-medium tw-text-[#6611119c]">
          <span className="tw-ml-auto">{item?.comment}</span>
        </div>
      </Card>
    ) : (
      <div>No History Found</div>
    );

  const actionBodyTemplate = (rowData: Supplier) => (
    <div className="tw-flex tw-gap-4">
      <Button
        className="p-button-rounded tw-p-0 tw-w-auto tw-h-auto focus:tw-shadow-none"
        onClick={() => handleEditUser(rowData)}
      >
        <EditButtonSVG />
      </Button>
      <InputSwitch
        checked={rowData.isActive}
        onChange={(e: InputSwitchChangeEvent) => {
          handleStatusChangeClick(rowData.supplierID, rowData.isActive);
        }}
        disabled={isSwitchDisabled && rowData.supplierID === selectedSupplierID}
      />
      <Button
        className="p-button-rounded tw-p-0 tw-w-auto tw-h-auto focus:tw-shadow-none"
        onClick={() => {
          setSelectedRowData(rowData);
          setSupplierStatusChangeActivity(rowData.supplierStatusChangeHistory);
          setViewHistoryPopup(true);
        }}
        tooltip="View Status History"
        tooltipOptions={{ position: "top" }}
      >
        <i className="pi pi-info-circle tw-text-[#00AFEE] tw-text-xl"></i>
      </Button>
    </div>
  );

  const supplierColumns: ColumnOption[] = [
    {
      field: "displayName",
      header: "Supplier Name",
      visible: true,
    },
    {
      field: "businessNumber",
      header: "Business Number",
      visible: true,
    },
    { field: "country", header: "Country", visible: true },
    { field: "currencySymbol", header: "Currency", visible: true },
    {
      field: "action",
      header: "Action",
      body: actionBodyTemplate,
      visible: true,
    },
  ];

  const handleCountryChange = (e: { value: Country }) => {
    const country = e.value;
    setSelectedCountry(country.countryID);
    setEditCountry(country);
    setCountryID(country.countryID); // Verify if this is being set
    setCurrencySymbol(country.currencySymbol);
  };

  return (
    <>
      <Toast ref={toast} />
      <div className="card">
        <div className="tw-flex tw-justify-end tw-items-center tw-w-full tw-gap-4 tw-bg-[#F8FAFC] tw-p-4 tw-mr-4">
          <Button
            className="tw-flex tw-px-3 tw-py-2 tw-rounded tw-font-medium tw-gap-2"
            severity="secondary"
            onClick={(event) => menu.current?.toggle(event)}
          >
            <FilterButtonSVG />
            <span className="tw-text-sm">Filters</span>
          </Button>
          <Menu
            className="tw-w-72"
            model={items as MenuItem[]}
            popup
            ref={menu}
          />

          <Button
            className="tw-flex tw-px-3 tw-py-2 tw-rounded bg-primary border-primary tw-text-white tw-font-medium"
            label="Add Supplier"
            icon="pi pi-plus"
            onClick={() => setDialogVisible(true)}
          />
          <Button
            type="button"
            icon="pi pi-upload"
            label="Export"
            loading={isExporting}
            className="tw-flex tw-px-9 tw-py-2 tw-rounded bg-secondary border-primary hover:tw-bg-[#3f3c3c] tw-text-white tw-font-medium focus:tw-shadow-none"
            onClick={() => fetchSuppliers(first / size, size, true, "export")}
          />
        </div>
        <div className="card-body tw-relative tw-min-h-80 table-p-0">
          {supplierListLoading ? (
            <div className="tw-h-full tw-w-full tw-bg-white tw-flex tw-justify-center tw-items-center tw-absolute tw-top-0 tw-left-0 tw-z-50">
              <ProgressSpinner />
            </div>
          ) : (
            <>
              <DataTableComponent
                rowData={suppliers}
                columns={supplierColumns}
              />

              <Paginator
                first={first}
                rows={size}
                totalRecords={totalRecords} // Set total records for pagination
                rowsPerPageOptions={[5, 10, 25, 50]}
                onPageChange={onPageChange}
              />
            </>
          )}
        </div>
      </div>

      <Dialog
        header="Add Supplier"
        visible={dialogVisible}
        style={{ width: "20vw" }}
        onHide={() => {
          if (!dialogVisible) return;
          setDialogVisible(false);
          setFormErrors((prevFormErrors) => ({
            ...prevFormErrors,
            supplierName: null,
            countryID: null,
            businessNumber: null,
            address: null,
          }));
          setCountryID(null);
          setSelectedCountry(null);
          setSupplierName(null);
          setBusinessNumber(null);
          setCurrencySymbol("");
        }}
      >
        <div className="tw-flex tw-flex-col">
          <div className="tw-mt-0 tw-flex tw-flex-col tw-gap-2">
            <label>Supplier Name</label>
            <InputText
              value={supplierName ?? ""}
              className={` ${
                formErrors.supplierName
                  ? "tw-border-red-600"
                  : "tw-border-gray-300"
              } tw-px-[14px] tw-py-[5px] tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-h-11 placeholder:tw-font-normal`}
              onChange={(e) => {
                setFormErrors((prevErrors) => ({
                  ...prevErrors,
                  supplierName: null,
                }));
                e.target.value === ""
                  ? setSupplierName(null)
                  : setSupplierName(e.target.value);
              }}
              placeholder="Enter Supplier Name"
            />
            {/* {formErrors.supplierName && (
              <p className="tw-text-red-600 tw-text-xs">
                {formErrors.supplierName}
              </p>
            )} */}
          </div>

          <div className="tw-mt-3 tw-flex tw-flex-col tw-gap-2">
            <label>Country</label>
            <Dropdown
              value={countryOptions.find(
                (option) => option.countryID === selectedCountry
              )}
              onChange={(e) => {
                setFormErrors((prevErrors) => ({
                  ...prevErrors,
                  countryID: null,
                }));
                handleCountryChange(e);
              }}
              options={countryOptions}
              optionLabel="countryName"
              placeholder="Select Country"
              className={`tw-border tw-border-solid ${
                formErrors.countryID
                  ? "tw-border-red-600"
                  : "tw-border-gray-300"
              } tw-border-gray-300 tw-rounded-md placeholder:tw-font-normal tw-w-full`}
            />
            {/* {formErrors.countryID && (
              <p className="tw-text-red-600 tw-text-xs">
                {formErrors.countryID}
              </p>
            )} */}
          </div>
          <div className="tw-mt-3 tw-flex tw-flex-col tw-gap-2">
            <label>Business Number</label>
            <InputText
              value={businessNumber ?? ""}
              className={`${
                formErrors.businessNumber
                  ? "tw-border-red-600"
                  : "tw-border-gray-300"
              } tw-px-[14px] tw-py-[5px] tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-h-11 placeholder:tw-font-normal`}
              onChange={(e) => {
                setFormErrors((prevErrors) => ({
                  ...prevErrors,
                  businessNumber: null,
                }));
                e.target.value === ""
                  ? setBusinessNumber(null)
                  : setBusinessNumber(e.target.value);
              }}
              placeholder="Enter Business Number"
            />
            {/* {formErrors.businessNumber && (
              <p className="tw-text-red-600 tw-text-xs">
                {formErrors.businessNumber}
              </p>
            )} */}
          </div>

          {currencySymbol && (
            <div className="tw-mt-3 tw-flex tw-flex-col tw-gap-2">
              <label>Currency</label>
              <div>{currencySymbol}</div>
            </div>
          )}
          <div className="tw-mt-3 tw-flex tw-flex-col tw-gap-2">
            <label>Address</label>
            <InputTextarea
              value={address}
              className={`tw-px-[14px] tw-py-[5px] tw-border tw-border-solid tw-border-gray-300 tw-rounded-md placeholder:tw-font-normal`}
              onChange={(e) => {
                setAddress(e.target.value);
              }}
              placeholder="Enter Address"
            />
            {/* {formErrors.address && (
              <p className="tw-text-red-600 tw-text-xs">{formErrors.address}</p>
            )} */}
          </div>
          <Button
            label="Add Supplier"
            className="tw-flex tw-px-3 tw-py-2 tw-rounded-lg bg-primary border-primary tw-text-white tw-font-medium tw-w-full tw-mt-8"
            onClick={handleAddSupplier}
            disabled={isAddButtonDisabled}
          />
        </div>
      </Dialog>
      <Dialog
        header="Edit Supplier"
        visible={editDialogVisible}
        style={{ width: "20vw" }}
        onHide={() => {
          if (!editDialogVisible) return;
          setEditDialogVisible(false);
          setFormErrors((prevFormErrors) => ({
            ...prevFormErrors,
            supplierName: null,
            countryID: null,
            businessNumber: null,
            address: null,
          }));
        }}
      >
        <div className="tw-flex tw-flex-col">
          <div className="tw-mt-0 tw-flex tw-flex-col tw-gap-2">
            <label>Supplier Name</label>
            <InputText
              value={editSupplierName?.split(" - ")[0] ?? ""}
              className={`${
                formErrors.supplierName
                  ? "tw-border-red-600"
                  : "tw-border-gray-300"
              } tw-px-[14px] tw-py-[5px] tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-h-11 placeholder:tw-font-normal`}
              onChange={(e) => {
                setFormErrors((prevErrors) => ({
                  ...prevErrors,
                  supplierName: null,
                }));
                e.target.value === ""
                  ? setEditSupplierName(null)
                  : setEditSupplierName(e.target.value);
              }}
              placeholder="Enter Supplier Name"
            />
            {/* {formErrors.supplierName && (
              <p className="tw-text-red-600 tw-text-xs">
                {formErrors.supplierName}
              </p>
            )} */}
          </div>
          <div className="tw-mt-3 tw-flex tw-flex-col tw-gap-2">
            <label>Business Number</label>
            <InputText
              value={editBusinessNumber ?? ""}
              className={`${
                formErrors.businessNumber
                  ? "tw-border-red-600"
                  : "tw-border-gray-300"
              } tw-px-[14px] tw-py-[5px] tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-h-11 placeholder:tw-font-normal`}
              onChange={(e) => {
                setFormErrors((prevErrors) => ({
                  ...prevErrors,
                  businessNumber: null,
                }));
                e.target.value === ""
                  ? setEditBusinessNumber(null)
                  : setEditBusinessNumber(e.target.value);
              }}
              placeholder="Enter Business Number"
            />
            {/* {formErrors.businessNumber && (
              <p className="tw-text-red-600 tw-text-xs">
                {formErrors.businessNumber}
              </p>
            )} */}
          </div>
          <div className="tw-mt-3 tw-flex tw-flex-col tw-gap-2">
            <label>Country</label>
            <Dropdown
              value={editCountry}
              onChange={(e) => {
                setFormErrors((prevErrors) => ({
                  ...prevErrors,
                  countryID: null,
                }));
                setEditCountry(e.value);
                setCurrencySymbol(e.value.currencySymbol);
              }}
              options={countryOptions}
              optionLabel="countryName"
              placeholder="Select Country"
              className={`${
                formErrors.countryID
                  ? "tw-border-red-600"
                  : "tw-border-gray-300"
              } tw-px-[14px] tw-py-[5px] tw-border tw-border-solid tw-border-gray-300 tw-rounded-md placeholder:tw-font-normal tw-w-full`}
            />
            {/* {formErrors.countryID && (
              <p className="tw-text-red-600 tw-text-xs">
                {formErrors.countryID}
              </p>
            )} */}
          </div>
          <div className="tw-mt-3 tw-flex tw-flex-col tw-gap-2">
            <label>Currency</label>
            <div>{currencySymbol}</div>
          </div>
          <div className="tw-mt-3 tw-flex tw-flex-col tw-gap-2">
            <label>Address</label>
            <InputTextarea
              value={editAddress ?? ""}
              className={`tw-px-[14px] tw-py-[5px] tw-border tw-border-solid tw-border-gray-300 tw-rounded-md placeholder:tw-font-normal`}
              onChange={(e) => {
                setEditAddress(e.target.value);
              }}
              placeholder="Enter Address"
            />
            {/* {formErrors.address && (
              <p className="tw-text-red-600 tw-text-xs">{formErrors.address}</p>
            )} */}
          </div>
          <Button
            label="Update Supplier"
            className="tw-flex tw-px-3 tw-py-2 tw-rounded-lg bg-primary border-primary tw-text-white tw-font-medium tw-w-full tw-mt-8"
            onClick={handleUpdateSupplier}
            disabled={isAddButtonDisabled}
          />
        </div>
      </Dialog>
      <Dialog
        header={`${
          pendingStatusChange?.isActive ? "Activate" : "Deactivate"
        } Supplier`}
        draggable={false}
        visible={isStatusDialogVisible}
        style={{ width: "28vw" }}
        onHide={() => {
          setIsStatusDialogVisible(false);
          setStatusChangeReason("");
          setPendingStatusChange(null);
        }}
      >
        <div className="tw-flex tw-flex-col tw-gap-4">
          <p>
            Please provide a reason for{" "}
            {pendingStatusChange?.isActive ? "activating" : "deactivating"} this
            supplier:
          </p>
          <InputText
            value={statusChangeReason}
            onChange={(e) => {
              setStatusChangeReason(e.target.value);
              setStatusChangeReasonError(null);
            }}
            placeholder="Enter reason..."
            className={`tw-px-[14px] tw-py-[5px] tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-h-11 placeholder:tw-font-normal ${
              statusChangeReasonError ? "tw-border-red-500" : ""
            }`}
          />
          {statusChangeReasonError && (
            <small className="tw-text-red-500">{statusChangeReasonError}</small>
          )}
          <div className="tw-flex tw-gap-2 tw-justify-end">
            <Button
              label="Cancel"
              className="tw-px-4 tw-py-2 tw-rounded-lg focus:tw-shadow-none tw-bg-gray-300 hover:tw-bg-gray-400 tw-text-gray-800 tw-font-medium"
              onClick={() => {
                setIsStatusDialogVisible(false);
                setStatusChangeReason("");
                setPendingStatusChange(null);
                setStatusChangeReasonError(null);
              }}
            />
            <Button
              label="Confirm"
              className="tw-px-4 tw-py-2 tw-rounded-lg focus:tw-shadow-none bg-primary border-primary hover:tw-bg-[#02a2db] tw-text-white tw-font-medium"
              onClick={confirmStatusChange}
              disabled={isSwitchDisabled}
            />
          </div>
        </div>
      </Dialog>

      <Dialog
        header={`Status Change History for ${
          selectedRowData?.displayName || "Supplier"
        }`}
        visible={viewHistoryPopup}
        style={{ maxWidth: "620px" }}
        onHide={() => setViewHistoryPopup(false)}
        closable
        className="comments-dialog tw-w-[444px]"
      >
        <>
          {supplierStatusChangeActivity &&
          supplierStatusChangeActivity.length !== 0 ? (
            <Timeline
              className="tw-p-4"
              align="left"
              marker={customizedMarker}
              content={customizedContent}
              value={events}
            />
          ) : (
            <div className="tw-p-4 tw-border-b tw-text-center tw-border-b-solid tw-border-b-[#DBDBDB]">
              <p className="tw-m-0 tw-text-sm tw-font-medium tw-text-[#64748B] tw-mb-2">
                No History Found
              </p>
            </div>
          )}
        </>
      </Dialog>
    </>
  );
}

export default SupplierManagement;
